import { Buttons } from '../../../controls/buttons';
import { Component, computed, inject, model, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { TransportService } from '../../services/transport.service';
import { TransportOutConfiguration } from '../../models/transport-configuration';
import { DistributionService } from 'src/app/distribution/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Selectbox } from '../../../controls/selectbox';

@Component({
    selector: 'app-transport-out-override-dialog',
    templateUrl: './transport-out-override-dialog.component.html',
    styleUrls: ['./transport-out-override-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [Selectbox, Buttons]
})
export class TransportOutOverrideDialogComponent implements OnInit {
  private transportService = inject(TransportService);
  private distributionService = inject(DistributionService);
  private dialog = inject(NgbActiveModal);

  overrideId = model<number>(0);
  initialOverrideId = signal(0);
  globalLocations = signal<TransportOutConfiguration[]>([]);
  distributionCount = signal<number>(-1);
  dialogStep = signal(1);
  selectedLocation = computed(() => this.globalLocations().find(e => e.Id === this.overrideId()));
  canNext = computed(() => {
    return !!this.selectedLocation() && this.overrideId() !== this.initialOverrideId();
  });

  ngOnInit(): void {
    this.init();
  }

  async init(): Promise<void> {
    this.initialOverrideId.set(this.overrideId());
    this.globalLocations.set(await this.transportService.getGlobalTransportOutConfigurations());
    this.distributionCount.set(await this.distributionService.getDistributionCount());
  }

  cancel(): void {
    this.dialog.dismiss();
  }

  goBack(): void {
    this.dialogStep.set(1);
  }

  confirmOverride(): void {
    this.dialogStep.set(2);
  }

  confirmStop(): void {
    this.dialogStep.set(3);
  }

  stopNow(): void {
    this.dialog.close(undefined);
  }

  overrideNow(): void {
    this.dialog.close(this.overrideId());
  }
}
